import { typeBuilder } from 'base/shared/TypeHelper';

export default typeBuilder(['TRANSACTIONS_ERROR', 'TRANSACTIONS_REQUEST', 'TRANSACTIONS_SUCCESS']);
